export default __webpack_public_path__ + "static/fa-brands-400-f51741c80a33908a2fcc84cc23667bf3.woff";